<template>
  <div>
    <button v-if='!added' @click.prevent='add_clicked'>Add</button>

    <div class="integer-picker" v-if='added'>
      <a v-if='quantity > min_limit' @click.prevent="$emit('update_quantity', quantity - 1)" class='adjust-quantity-button'>-</a>
      <span v-if='quantity <= min_limit' class='adjust-quantity-button adjust-quantity-button-disabled'>-</span>
      <input class="quantity" type='number' min='0' v-bind:value="quantity" v-on:input="$emit('update_quantity', $event.target.value)">
      <a @click.prevent="$emit('update_quantity', quantity + 1)" class='adjust-quantity-button'>+</a>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      added: { default: false },
      quantity: { default: 0 },
      min_limit: { default: 0 },
    },
    methods: {
      add_clicked() {
        this.$emit('add')
        this.$emit('update_quantity', this.quantity + 1)
      },
    },
  }
</script>
